/** @module csi/action/_ImageSaveMixin */
define([
	"dojo/_base/declare",
	"csi/_base/underscore",
	"csi/comm",
	"csi/image/_base",
	"csi/reflection",
	"csi/xml"
], function(declare,_,comm,imageBase,reflection,xml) {

	return declare(null, {
		/** @property {string} _firstKey - key to first image added */
		_firstKey: null,

		/** @property {string[]} _imageUrls  list of image urls to add */
		_imageUrls: null,

		/**
		 * Extension point called when on save changes
		 * @param {Node[]} nodes
		 */
		onSave: function(nodes) { },

		/**
		 * Finish the action
		 */
		_onCancel: function() {
			this.resumeProcess();
			this.postProcess();
		},

		/**
		 * Add nodes to this view's cache and save to attribute in context
		 * @property {ImageNode[]) nodes
		 */
		_onSave: function(nodes) {
			this._imageUrls = _.map(nodes, xml.nodeGetURL, xml);
			if (nodes.length) {
				// request image nodes from server and cached in memory
				var req = comm.getNodeRequest(this._imageUrls); // this should never be null
				req = this.m_cache.reduceNodesRequest(req);
				var dfd = req ? this.m_cache.addRequestDeferred(req) : null;
				this.when(dfd, function() {
					this.resumeProcess();
					this.process();
					this.onSave(nodes);
				}.bind(this));
			} else {
				this._onCancel();
			}
		},

		getStringParameters: function() {
			var node = this.getNode() || this.getParent();
			return (this._imageUrls && node) ? [this._imageUrls.length, node.$Name] : null;
		},

		/**
		 * Add selected image(s) to node
		 * @param {string{ id
		 * @param {String} type
		 */
		_toWriterImages: function(id, type) {
			var	node = this.getNode();
			var	value = node[id];
			var	cn = this.m_writer.changeNode(this.m_urlNode);

			// disable expression on attribute if one
			if (xml.nodeAttributeHasExpression(node, id)) {
				cn.disableAttributeExp(id);
			}

			// update attribute - handle map, array, and single value
			if (type == xml.ATTR_REFMAP) {
				var urlmap = {};
				if (id == reflection.ATTR_IMAGES) {
					urlmap = imageBase.getImageMapDifference(value, this._imageUrls, true);
					var	keys = _.sortBy(_.keys(urlmap), Number);

					// store first key added to map to be used by derived controllers to show first new image
					if (keys.length) {
						this._firstKey = keys[0];

						if (this._firstKey == reflection.DEFAULT_IMAGE_LABEL) {
							this._firstKey = keys[1];
						}
					} else {
						this._firstKey = imageBase.getNumberedKey(value, this._imageUrls[0]);
					}
				}

				// if key into map is specified on controller, then set it to the first image
				if (this.keyContainer != null) {
					urlmap[this.keyContainer] = this._imageUrls[0];
				}

				cn.changeAttributeKeys(id, xml.ATTR_REFMAP, urlmap, true);
			} else if(xml.attributeTypeIsContainer(type)) {
				// add new images that are not already in list
				cn.changeAttribute(id, type, _.difference(this._imageUrls, value), true);
			} else {
				cn.changeAttribute(id, xml.ATTR_REF, this._imageUrls[0]);
			}

			cn.changeAttributeFlag(id, xml.ATTR_FLAG_MODIFIED_BY_CLIENT, true);

			return cn;
		}
	});
});